import { render } from "./add-role-modal.vue?vue&type=template&id=0cd31dbc&scoped=true"
import script from "./add-role-modal.vue?vue&type=script&lang=js"
export * from "./add-role-modal.vue?vue&type=script&lang=js"

import "./add-role-modal.vue?vue&type=style&index=0&id=0cd31dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd31dbc"]])

export default __exports__